import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'

import history from '../../../route/history'

const RegisSimplePreTitle = (props) => {

  const [state, setState] = useState({
    userInfo: props.userInfo,
  })

  function objectToString(key) {
    let info = ''
    if (props.match.params?.[key] != null && props.match.params?.[key] != undefined) {
      info = Object.values(props.match.params?.[key])
      info = info.toString().replaceAll(',','')
    }
    return info
  }
  //사용자 가입용 데이터
  const [userInfo, setUserInfo] = useState({
    groupName: objectToString('groupName'),
    groupRegistno: objectToString('groupRegistno'),
    memberName: objectToString('memberName'),
    mobileNo: objectToString('mobileNo'),
    bplcCd: objectToString('bplcCd'),
    email: objectToString('email'),

  })

  useEffect(() => {
    history.replace({pathname: '/regis/simpleTitle',  state: { type: 'link', userInfo }})
  }, [])

  return (
    <React.Fragment>
      <div id="contents">

      </div>
      {/* <Alert /> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {  }
}

const actionCreators = {}

export default connect(mapStateToProps, actionCreators)(RegisSimplePreTitle)
